import { render, staticRenderFns } from "./sysRoleManagement.vue?vue&type=template&id=f383e9f6"
import script from "./sysRoleManagement.vue?vue&type=script&lang=js"
export * from "./sysRoleManagement.vue?vue&type=script&lang=js"
import style0 from "./sysRoleManagement.vue?vue&type=style&index=0&id=f383e9f6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports